import React from 'react';
import classNames from 'classnames';

import { useTextInput } from '../../../../hooks';

export const TextField = React.forwardRef((props, ref) => {
	const { inputProps, errorMessage } = useTextInput(props, ref);

	return (
		<div
			className={classNames('TextInput formElement formElement-text ValidatedForm-Field', {
				'TextInput--no-label': !inputProps.label,
			})}
		>
			<input {...inputProps} />

			{inputProps.label && (
				<label className="formElement-label ty-c4" htmlFor={inputProps.id}>
					{inputProps.label}
				</label>
			)}

			{errorMessage && (
				<span className="formElement-message" role="alert">
					{errorMessage}
				</span>
			)}
		</div>
	);
});

export default TextField;
